import { ProductCard } from '@components/display/cards';
import { IntlShape } from 'react-intl';

export const LoadingProductCard = ({ intl }: { intl: IntlShape }) => (
    <ProductCard
        image={{
            url: '/static/img/backgrounds/LeftSplitImageDesktop1.png',
            alt_text: intl.formatMessage({
                id: 'event.loadingThumbnail',
                defaultMessage: 'Loading event thumbnail',
            }),
        }}
        baseUrl=""
        date="Loading"
        slug="123"
        title="Loading"
        loading
    />
);
